import { getProfessionalCampaigns } from './GetProfessionalCampaigns';
import { getPromoCodes } from './GetPromoCodes';
import { getPromoCode } from './GetPromoCode';
import { getPromoCodeReport } from './GetPromoCodeReport';
import { getPromoCodeTargetOffices } from './GetPromoCodeTargetOffices';
import { getOfficeDiscountHistory } from './GetOfficeDiscountHistory';

export const CampaignsService = {
  getProfessionalCampaigns,
  getPromoCodes,
  getPromoCode,
  getPromoCodeReport,
  getPromoCodeTargetOffices,
  getOfficeDiscountHistory,
};
